export default __webpack_public_path__ + "static/media/emoji.240996e8.svg";